import { useState } from "react";
import { api, apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useI18n } from "@/i18n";
import { PageHeader } from "@/components/common";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function Profile() {
  const { user } = useAuth();
  const { t } = useI18n();
  const [cur, setCur] = useState("");
  const [n1, setN1] = useState("");
  const [n2, setN2] = useState("");
  const [busy, setBusy] = useState(false);

  const save = async () => {
    if (n1.length < 8) { toast.error(t("prof.tooShort")); return; }
    if (n1 !== n2) { toast.error(t("prof.mismatch")); return; }
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: n1 });
      toast.success(t("prof.changed"));
      setCur(""); setN1(""); setN2("");
    } catch (e) { toast.error(apiError(e)); }
    finally { setBusy(false); }
  };

  return (
    <div className="max-w-lg">
      <PageHeader title={t("prof.title")} subtitle={t("prof.subtitle")} />
      <div className="rounded-md border border-border bg-card p-5 shadow-sm mb-6 space-y-1.5" data-testid="profile-info">
        <div className="text-sm"><span className="text-muted-foreground">{t("common.name")}:</span> {user?.name}</div>
        <div className="text-sm"><span className="text-muted-foreground">{t("common.email")}:</span> {user?.email}</div>
        <div className="text-sm"><span className="text-muted-foreground">{t("common.role")}:</span> {t(`role.${user?.role}`, user?.role)}</div>
      </div>
      <div className="rounded-md border border-border bg-card p-5 shadow-sm space-y-4">
        <h3 className="font-heading text-lg font-medium">{t("prof.changePassword")}</h3>
        <div><Label>{t("prof.current")}</Label><Input type="password" className="mt-1.5" value={cur} onChange={(e) => setCur(e.target.value)} data-testid="pw-current" /></div>
        <div><Label>{t("prof.new")}</Label><Input type="password" className="mt-1.5" value={n1} onChange={(e) => setN1(e.target.value)} data-testid="pw-new" /></div>
        <div><Label>{t("prof.confirm")}</Label><Input type="password" className="mt-1.5" value={n2} onChange={(e) => setN2(e.target.value)} data-testid="pw-confirm" /></div>
        <Button onClick={save} data-testid="pw-save-btn" disabled={busy || !cur || !n1 || !n2}>{t("prof.changePassword")}</Button>
      </div>
    </div>
  );
}
